import type { GetDoneMark } from '../types';

export const SSRGetDoneMark = {
	getDoneMark: (() => null) as GetDoneMark,
	setGetDoneMark: (fn: GetDoneMark): void => {
		SSRGetDoneMark.getDoneMark = fn;
	},
};
